<template>
  <div class="n8n-page">
    <!-- Loading Overlay -->
    <div class="n8n-loading-overlay" v-if="loading">
      <span class="n8n-spinner n8n-spinner--lg"></span>
    </div>

    <!-- Header -->
    <header class="n8n-header">
      <div class="n8n-header__brand">
        <img src="../assets/images/logo2.png" class="n8n-header__logo" loading="lazy" alt="Logo" />
      </div>
      <div class="n8n-header__wallet">
        <img src="../assets/images/coin.png" width="22" alt="Coin" />
        <span class="n8n-header__coins">{{ mycoin }}</span>
      </div>
      <div class="n8n-header__avatar" :style="{ backgroundImage: `url(${pictureUrl})` }"></div>
    </header>

    <!-- Main Content -->
    <main class="n8n-main">
      <!-- Page Hero -->
      <div class="n8n-hero">
        <div class="n8n-hero__icon">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="8" r="7"/>
            <polyline points="8.21,13.89 7,23 12,20 17,23 15.79,13.88"/>
          </svg>
        </div>
        <h1 class="n8n-hero__title">แลกของรางวัล</h1>
        <p class="n8n-hero__subtitle">ใช้เหรียญแลกรับของรางวัลพิเศษ</p>
        <p v-if="redemptionClosed" class="n8n-hero__subtitle">ปิดแลกเหรียญเพื่อย้ายยอดไป Shiba88 กรุณาติดต่อแอดมิน</p>
      </div>

      <!-- Tabs -->
      <div class="n8n-tabs">
        <button 
          class="n8n-tab" 
          :class="{ 'n8n-tab--active': currentTab === 'tab1' }"
          @click="handleClick('tab1')"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="12" y1="1" x2="12" y2="23"/>
            <path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/>
          </svg>
          <span>เครดิต</span>
        </button>
        <button 
          class="n8n-tab" 
          :class="{ 'n8n-tab--active': currentTab === 'tab2' }"
          @click="handleClick('tab2')"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="3" y="3" width="18" height="18" rx="2"/>
            <path d="M3 9h18"/>
            <path d="M9 21V9"/>
          </svg>
          <span>ของรางวัล</span>
        </button>
      </div>

      <!-- Tab 1: Credits -->
      <div class="n8n-rewards" v-if="currentTab === 'tab1'">
        <div v-for="(items, index) in rewards" :key="index" class="n8n-rewards__row">
          <div 
            v-for="(item, index2) in items" 
            :key="index + '-' + index2" 
            class="n8n-reward-card"
          >
            <div class="n8n-reward-card__image">
              <img :src="item.image" :alt="item.name" />
            </div>
            <div class="n8n-reward-card__content">
              <h3 class="n8n-reward-card__name">{{ item.name }}</h3>
              <p class="n8n-reward-card__desc">{{ item.description }}</p>
            </div>
            <button 
              class="n8n-reward-card__btn"
              :class="mycoin >= item.coin ? 'n8n-reward-card__btn--active' : 'n8n-reward-card__btn--disabled'"
              :disabled="isDisabled || mycoin < item.coin"
              @click="redeem(item)"
            >
              <img src="../assets/images/coin.png" width="18" alt="Coin" />
              <span>แลก {{ item.coin }}</span>
            </button>
          </div>
        </div>

        <!-- Empty State -->
        <div class="n8n-empty" v-if="rewards.length === 0">
          <div class="n8n-empty__icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <circle cx="12" cy="8" r="7"/>
              <polyline points="8.21,13.89 7,23 12,20 17,23 15.79,13.88"/>
            </svg>
          </div>
          <h3 class="n8n-empty__title">ไม่มีรางวัล</h3>
          <p class="n8n-empty__text">กำลังโหลดข้อมูลรางวัล...</p>
        </div>
      </div>

      <!-- Tab 2: Coming Soon -->
      <div class="n8n-coming-soon" v-else>
        <div class="n8n-coming-soon__icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
          </svg>
        </div>
        <h3 class="n8n-coming-soon__title">Coming Soon</h3>
        <p class="n8n-coming-soon__text">รางวัลเพิ่มเติมกำลังจะมาเร็วๆ นี้</p>
      </div>
    </main>

    <!-- Bottom Menu -->
    <BottomMenu></BottomMenu>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/database";
import moment from "moment-timezone";
const axios = require("axios").default;
import router from "./../router";
import _ from 'lodash';
import liffService from "@/services/liff";
// @ is an alias to /src
export default {
  name: "Register",
  created() {
    // LIFF is already initialized by router guard
    this.loadUserData();
  },
  components: {
    BottomMenu: require("./BottomMenu").default,
  },
  data() {
    return {
      tabs: [
      { title: 'เครดิต', value: 'tab1' },
      { title: 'ของรางวัล', value: 'tab2' },
      ],
      currentTab: 'tab1',
      displayName: "",
      //email: "",
      userId: "",//Uf67a993bc2d1d206693634a1ba806798
      pictureUrl: "",
      statusMessage: "",
      firstname: "",
      master: "5",
      agent: "-MBjPYX3fRJGs3gklUHq",
      lastname: "",
      bank: "",
      accountNo: "",
      tel: "",
      mastername: "",
      isDisabled: true,
      loading: false,
      error: "",
      mycoin:0,
      rewards:[],
      userKey:'',
      redemptionClosed:false,
    };
  },
  methods: {
    handleClick(newTab) {
      this.currentTab = newTab;
    },
    redeem: function(item){
      if(this.redemptionClosed) return;
      if(!this.isDisabled){
        if(this.mycoin>=item.coin){
          this.$confirm(
          {
            title: 'Are you sure?',
            message: `‼️ ยืนยันต้องการแลก ${item.coin} Coins กับ ${item.name}?`,
            button: {
              no: 'No',
              yes: 'Yes'
            },
            /**
            * Callback Function
            * @param {Boolean} confirm 
            */
            callback: confirm => {
              if (confirm && this.userKey) {
                  this.isDisabled = true;
                  this.loading = false;
                  const coin = this.mycoin-item.coin;
                  this.mycoin = coin;
                  firebase.database().ref(`/users/${this.userKey}`).update({
                    coins:coin
                  }).then(async()=>{
                    await firebase.firestore().collection('redeemreward').add({
                      userId:this.userId,
                      createdate:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
                      rewardId:item.key,
                      coin:item.coin,
                      credit:item.credit,
                    });
                    this.sendMessageLine(coin,item);
                  });
              }else{
                this.loading = false;
              }
            }
          }
        )
        }
      }
    },
    async sendMessageLine(coin,item){
      await window.liff.sendMessages([
          {
          "type": "flex",
          "altText": "แลกของรางวัล",
          "contents": {
                "type": "bubble",
                "body": {
                  "type": "box",
                  "layout": "vertical",
                  "contents": [
                    {
                      "type": "box",
                      "layout": "horizontal",
                      "contents": [
                        {
                          "type": "image",
                          "url": item.image,
                          "size": "full",
                          "aspectRatio": "1:1",
                          "gravity": "center",
                          "flex": 1,
                          "aspectMode": "fit"
                        }
                      ]
                    },
                    {
                      "type": "box",
                      "layout": "horizontal",
                      "contents": [
                        {
                          "type": "box",
                          "layout": "vertical",
                          "contents": [
                            {
                              "type": "image",
                              "url": this.pictureUrl,
                              "aspectMode": "cover",
                              "size": "full"
                            }
                          ],
                          "cornerRadius": "100px",
                          "width": "72px",
                          "height": "72px"
                        },
                        {
                          "type": "box",
                          "layout": "vertical",
                          "contents": [
                            {
                              "type": "text",
                              "contents": [
                                {
                                  "type": "span",
                                  "text": this.displayName,
                                  "weight": "bold",
                                  "color": "#000000"
                                },
                                {
                                  "type": "span",
                                  "text": "     "
                                },
                                {
                                  "type": "span",
                                  "text": "ใช้ "+item.coin+" coins แลกรางวัล "+item.name
                                }
                              ],
                              "size": "sm",
                              "wrap": true
                            },
                            {
                              "type": "box",
                              "layout": "baseline",
                              "contents": [
                                {
                                  "type": "text",
                                  "text": "จำนวน coins ที่เหลือ "+coin,
                                  "size": "sm",
                                  "color": "#bcbcbc"
                                }
                              ],
                              "spacing": "sm",
                              "margin": "md"
                            }
                          ]
                        }
                      ],
                      "spacing": "xl",
                      "paddingAll": "20px"
                    }
                  ],
                  "paddingAll": "0px"
                }
              }
          },
          {
            "type": "text",
            "text": "โปรดรอสักครู่น้องออโต้กำลังจัดการให้อยู่ค่ะ 😘😘",
          }
        ]);
        window.liff.closeWindow();
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async loadUserData() {
      const redemptionEnabled = (await firebase.database().ref('/migration/public/coinRedemptionEnabled').once('value')).val();
      this.redemptionClosed = redemptionEnabled === false;
      if(this.redemptionClosed) this.isDisabled = true;
      const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
      
      // Get profile from centralized service (already fetched by router guard)
      let profile = liffService.profile;
      
      // Mock LIFF profile for localhost development
      if (isLocalhost && !profile) {
        profile = {
          userId: "UmockUserIdForDev",
          displayName: "Dev Tester",
          pictureUrl: "",
          statusMessage: ""
        };
      }
      
      if (!profile) return;

      this.userId = profile.userId || "none";
      this.displayName = profile.displayName || "none";
      this.pictureUrl = profile.pictureUrl || "none";
      this.statusMessage = profile.statusMessage || "none";
      
      if (this.userId) {
        // Development mode: show mock rewards on localhost
        if (isLocalhost) {
          this.mycoin = 999;
          // Create mock rewards for testing
          const mockRewards = [
            { key: 'mock1', name: 'เครดิต 50 บาท', description: 'รับเครดิตฟรี 50 บาท', coin: 100, credit: 50, image: 'https://via.placeholder.com/200x150/ff6b35/ffffff?text=50+Credit' },
            { key: 'mock2', name: 'เครดิต 100 บาท', description: 'รับเครดิตฟรี 100 บาท', coin: 200, credit: 100, image: 'https://via.placeholder.com/200x150/10b981/ffffff?text=100+Credit' },
            { key: 'mock3', name: 'เครดิต 200 บาท', description: 'รับเครดิตฟรี 200 บาท', coin: 350, credit: 200, image: 'https://via.placeholder.com/200x150/7c3aed/ffffff?text=200+Credit' },
            { key: 'mock4', name: 'เครดิต 500 บาท', description: 'รับเครดิตฟรี 500 บาท สำหรับสมาชิกพิเศษ', coin: 800, credit: 500, image: 'https://via.placeholder.com/200x150/f59e0b/ffffff?text=500+Credit' },
          ];
          this.rewards = [mockRewards.slice(0, 2), mockRewards.slice(2, 4)];
          this.userKey = 'mockUserKey';
          this.isDisabled = this.redemptionClosed;
          return;
        }
        
        const user = (await firebase.database().ref(`/users`).orderByChild('userId').equalTo(this.userId).once("value")).val();
        if (user) {
            const u = user[Object.keys(user)[0]];
            this.mycoin = u.coins;
            const rewards2 = (await firebase.database().ref(`/rewards`).once("value")).val();
            const rewards = [];
            for(const x in rewards2){
              rewards2[x].key = x;
              rewards.push(rewards2[x]);
            }
            const rewards3 = _.orderBy(rewards,['coin'],['asc']);
            const rewardsdata = [];
          let i = 0;
          let page = 0;
          for(const x in rewards3){
            if(!rewardsdata[page]) {
              rewardsdata[page] = [];
            }
            rewardsdata[page].push(rewards3[x]);
            if(i%2 == 1){
              page++;
            }
            i++;
          }
          this.rewards = rewardsdata;
          this.userKey = Object.keys(user)[0];
        }else{
          router.replace("/register");
        }
      }
      this.isDisabled = this.redemptionClosed;
    }
  }
};
</script>

<style lang="scss" scoped>
// ============================================================================
// N8N THEME - REWARD PAGE
// ============================================================================

// Design Tokens
$n8n-bg: #0a0a0a;
$n8n-surface: #151515;
$n8n-surface-hover: #1f1f1f;
$n8n-border: rgba(255, 255, 255, 0.08);
$n8n-primary: #FF6B35;
$n8n-primary-soft: rgba(255, 107, 53, 0.15);
$n8n-success: #10b981;
$n8n-success-soft: rgba(16, 185, 129, 0.15);
$n8n-purple: #a855f7;
$n8n-purple-soft: rgba(168, 85, 247, 0.15);
$n8n-text: #ffffff;
$n8n-text-secondary: rgba(255, 255, 255, 0.6);
$n8n-text-muted: rgba(255, 255, 255, 0.4);
$n8n-radius: 12px;
$n8n-radius-sm: 8px;

.n8n-page {
  min-height: 100vh;
  background: transparent;
  color: $n8n-text;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  padding-bottom: 100px;
}

// Loading Overlay
.n8n-loading-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  z-index: 1000;
}

// Spinner
.n8n-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid $n8n-border;
  border-top-color: $n8n-primary;
  border-radius: 50%;
  animation: n8n-spin 0.8s linear infinite;
  
  &--lg {
    width: 40px;
    height: 40px;
    border-width: 3px;
  }
}

@keyframes n8n-spin {
  to { transform: rotate(360deg); }
}

// Header
.n8n-header {
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.25rem;
  padding-top: calc(1rem + env(safe-area-inset-top, 0px));
  background: rgba(10, 10, 10, 0.85);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-bottom: 1px solid $n8n-border;

  &__brand {
    flex: 1;
  }

  &__logo {
    height: 44px;
    width: auto;
  }

  &__wallet {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    background: $n8n-primary-soft;
    border: 1px solid rgba(255, 107, 53, 0.2);
    border-radius: 50px;
  }

  &__coins {
    font-size: 0.9rem;
    font-weight: 700;
    color: $n8n-primary;
  }

  &__avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-size: cover;
    background-position: center;
    background-color: $n8n-surface;
    border: 2px solid $n8n-border;
  }
}

// Main Content
.n8n-main {
  padding: 1.5rem 1rem;
  max-width: 600px;
  margin: 0 auto;
}

// Hero Section
.n8n-hero {
  text-align: center;
  margin-bottom: 1.5rem;
  
  &__icon {
    width: 64px;
    height: 64px;
    margin: 0 auto 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, $n8n-purple 0%, #7c3aed 100%);
    border-radius: 16px;
    color: white;
    box-shadow: 0 8px 32px rgba(168, 85, 247, 0.3);
  }

  &__title {
    font-size: 1.75rem;
    font-weight: 700;
    margin: 0 0 0.5rem;
    background: linear-gradient(135deg, #fff 0%, rgba(255,255,255,0.8) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  &__subtitle {
    font-size: 0.95rem;
    color: $n8n-text-secondary;
    margin: 0;
  }
}

// Tabs
.n8n-tabs {
  display: flex;
  gap: 0.5rem;
  padding: 0.375rem;
  background: $n8n-surface;
  border: 1px solid $n8n-border;
  border-radius: 50px;
  margin-bottom: 1.5rem;
}

.n8n-tab {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: transparent;
  border: none;
  border-radius: 50px;
  color: $n8n-text-muted;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  
  svg {
    opacity: 0.6;
  }

  &--active {
    background: $n8n-primary;
    color: white;
    box-shadow: 0 4px 12px rgba(255, 107, 53, 0.3);
    
    svg {
      opacity: 1;
    }
  }
}

// Rewards Grid
.n8n-rewards {
  &__row {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem;
    margin-bottom: 0.75rem;
  }
}

// Reward Card
.n8n-reward-card {
  background: $n8n-surface;
  border: 1px solid $n8n-border;
  border-radius: $n8n-radius;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: transform 0.2s ease, border-color 0.2s ease;
  
  &:active {
    transform: scale(0.98);
  }

  &__image {
    position: relative;
    padding-top: 75%;
    background: #fff;
    
    img {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__content {
    flex: 1;
    padding: 0.875rem;
    display: flex;
    flex-direction: column;
  }

  &__name {
    font-size: 0.9rem;
    font-weight: 600;
    color: $n8n-primary;
    margin: 0 0 0.375rem;
    line-height: 1.3;
  }

  &__desc {
    font-size: 0.75rem;
    color: $n8n-text-secondary;
    margin: 0;
    line-height: 1.4;
    flex: 1;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  &__btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.375rem;
    padding: 0.75rem;
    border: none;
    font-size: 0.8rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;

    &--active {
      background: linear-gradient(135deg, $n8n-primary 0%, #E55520 100%);
      color: white;
      
      &:active {
        filter: brightness(0.9);
      }
    }

    &--disabled {
      background: rgba(255, 255, 255, 0.05);
      color: $n8n-text-muted;
      cursor: not-allowed;
    }
  }
}

// Empty State
.n8n-empty {
  text-align: center;
  padding: 3rem 2rem;
  background: $n8n-surface;
  border: 1px solid $n8n-border;
  border-radius: $n8n-radius;

  &__icon {
    margin-bottom: 1rem;
    color: $n8n-text-muted;
  }

  &__title {
    font-size: 1.125rem;
    font-weight: 600;
    color: $n8n-text;
    margin: 0 0 0.5rem;
  }

  &__text {
    font-size: 0.9rem;
    color: $n8n-text-muted;
    margin: 0;
  }
}

// Coming Soon
.n8n-coming-soon {
  text-align: center;
  padding: 4rem 2rem;
  background: $n8n-surface;
  border: 1px solid $n8n-border;
  border-radius: $n8n-radius;

  &__icon {
    margin-bottom: 1.5rem;
    color: $n8n-purple;
    animation: n8n-pulse 2s ease-in-out infinite;
  }

  &__title {
    font-size: 1.5rem;
    font-weight: 700;
    color: $n8n-text;
    margin: 0 0 0.5rem;
  }

  &__text {
    font-size: 0.95rem;
    color: $n8n-text-secondary;
    margin: 0;
  }
}

@keyframes n8n-pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.7; transform: scale(0.95); }
}
</style>
